import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, NgZone, OnInit } from '@angular/core';
import { ComponentsService, Outlet2Service , IscontrolComponent} from '@ic-builder/is-base';
import { Store } from '@ngxs/store';
import { MatDialog } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'ic-builder-isupload',
  templateUrl: './isupload.component.html',
  styleUrls: ['./isupload.component.scss'],
})
export class IsuploadComponent extends IscontrolComponent implements OnInit, AfterViewInit {
  constructor(
    public el: ElementRef,
    public store: Store,
    public comp: ComponentsService,
    public outlet: Outlet2Service,
    public NgZone: NgZone,
    public dialog: MatDialog,
    public cd: ChangeDetectorRef,
  ) {
    super(comp, store, outlet, NgZone, dialog, el, cd);
  }

  @Input() icon: string;
  @Input() accept = '*';
  @Input() showName: boolean = false; 
  @Input() arraybuffer: boolean = false;

  onupload: Function = null;

  formControlName: FormControl | null = null;
  formControlContent: FormControl | null = null;

  ngOnInit(): void {
    const controlNameId = super.initControl(this.id.toString() + '.name', null, 'name', null, false);
    this.formControlName = super.getFormControl(controlNameId);

    const controlContentId = super.initControl(this.id.toString() + '.content', null, 'content', null, false);
    this.formControlContent = super.getFormControl(controlContentId);
  }

  ngAfterViewInit() {
    // this.el.nativeElement.classList.add('material-icons');
  }

  getImg(ev) {
    const files = ev.target.files;
    let counter = 0;

    const resolvedFiles = [];

    while (counter<files.length){
      const file = files[counter];

      this.formControlName.setValue(null);
      this.formControlContent.setValue(null);
      const reader  = new FileReader();

      reader.onload = (e) => {


        resolvedFiles.push({ name: file.name, result: e.target.result });


        if (resolvedFiles.length === files.length) {
          this.formControlName.setValue(resolvedFiles.map(({ name }) => name));
          this.formControlContent.setValue(resolvedFiles.map(({ result }) => result));

          if (this.onupload) {
            if (files.length === 1) {
              this.onupload(e.target.result, file.name);
            } else {
              this.onupload(
                resolvedFiles.map(({ result }) => result),
                resolvedFiles.map(({ name }) => name),
              )
            }
          }

          this.cd.detectChanges();

        }

        

        
      };
      this.arraybuffer?reader.readAsArrayBuffer(file):reader.readAsDataURL(file);
      counter++;
    }
  }
}
